<template>
  <IconFont :type="name" :style="{ color: color, 'font-size': size + 'px' }" />
</template>

<script>
import { createFromIconfontCN } from "@ant-design/icons-vue";

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_3320422_0flzv53i0ut6.js",
});

import { defineComponent } from "vue";
export default defineComponent({
  components: {
    IconFont,
  },
  emits: [],
  props: {
    name: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 20,
    },
  },
});
</script>
